import {Alert, Button, Checkbox, FormControlLabel, Link, Typography} from '@mui/material';
import {Trans} from 'react-i18next';
import {useLegalDocument} from '@mybake/ui/hooks/useLegalDocument';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {landingUrl} from '../../common/landingUrl';
import {useRegistrationLegal} from './useRegistrationLegal';

export default function RegistrationConsent({legal}: {legal?: ReturnType<typeof useRegistrationLegal>}) {
    const {t} = useAppTranslation();
    const documents = useLegalDocument();
    const link = (path: string) => <Link href={documents.hrefFor(new URL('/pl/' + path, landingUrl).href) + (legal ? '&closeOnReturn=1' : '')} onClick={documents.remember} target={legal ? '_blank' : undefined} rel={legal ? 'noopener noreferrer' : undefined}/>;
    const components = {terms: link('regulamin'), privacy: link('polityka-prywatnosci'), dpa: link('DPA')};
    return <>
        {legal && <>
            {legal.updated && <Alert severity="warning">{t('registration:legal_updated' as never)}</Alert>}
            {!legal.ready && <Alert severity={legal.loading ? 'info' : 'error'}>{t((legal.loading ? 'registration:loading' : 'registration:legal_load_error') as never)}{!legal.loading && <Button onClick={legal.retry}>{t('registration:retry')}</Button>}</Alert>}
            <FormControlLabel control={<Checkbox required checked={legal.accepted} disabled={!legal.ready} onChange={event => legal.setAccepted(event.target.checked)}/>} label={<Trans ns="registration" i18nKey="account_consent" components={components}/>}/>
        </>}
        <Typography variant="body2" color="text.secondary"><Trans ns="registration" i18nKey={legal ? 'privacy_notice' : 'application_consent'} components={components}/></Typography>
    </>;
}
